import { Component, OnInit } from '@angular/core';
import * as appConstants from '../../assets/json/applicationConstants.json';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.css']
})
export class TermsAndConditionsComponent implements OnInit {
  brandData = appConstants?.commonAppConstants?.brandData;
  constructor() { }

  ngOnInit(): void {
  }

}
